module.exports = __webpack_public_path__ + "img/banner2.d86c91ce.jpg";